window.addEventListener('DOMContentLoaded', () => {
	// Dynamically calculate scrollbar width and update the CSS variable.
	const scrollbarWidth = () => {
		let w = window.innerWidth - document.documentElement.clientWidth;
		document.documentElement.style.setProperty('--grrr-ui-out', w + "px");
	};
	new ResizeObserver(scrollbarWidth).observe(document.body);
});
